import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invalid-path',
  templateUrl: './invalid-path.component.html',
  styleUrls: ['./invalid-path.component.css']
})
export class InvalidPathComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
